// Domain
import * as contentUseCases from './contentUseCases';

/**
 *
 * @returns {{ getTranslationFromContent: contentUseCases.GetTranslationFromContent,
 * getContentStatusUIConfig: contentUseCases.getContentStatusUIConfig,
 * CONTENT_STATUS: contentUseCases.ContentStatusEnum }}
 */
const useContent = () => ({
  getTranslationFromContent: contentUseCases.getTranslationFromContent,
  getContentStatusUIConfig: contentUseCases.getContentStatusUIConfig,
  CONTENT_STATUS: contentUseCases.CONTENT_STATUS,
});

export default useContent;
